const translations = {
  "en": {
    "no more news": "no more news",
    "no news": "no news"
  },
  "zh-tw": {
    "no more news": "沒有更多新聞",
    "no news": "沒有消息"
  }
};

export default translations;
